import React from 'react';
import { apiHolder, apis, getIn18Text } from 'api';
import style from './updateApp.module.scss';
const upgradeAppApi = apiHolder.api.requireLogicalApi(apis.upgradeAppApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
function trackUpdateIconClickEvent() {
    try {
        trackApi.track('pc_click_update_leftSideBar');
    }
    catch (ex) {
        console.error('trackUpdateIconClickEvent error', ex);
    }
}
const UpdateApp = () => {
    if (!window || !window.electronLib) {
        return null;
    }
    const showNewVersionDesc = async () => {
        trackUpdateIconClickEvent();
        const data = upgradeAppApi.getPendingUpdateInfo();
        if (data) {
            upgradeAppApi.showNewVersionAppDescDialog(Object.assign(Object.assign({}, data), { forcePopup: true }));
        }
    };
    const containerStyle = process.env.BUILD_ISEDM
        ? {
            marginTop: 4,
            height: 48,
        }
        : undefined;
    return (React.createElement("div", { className: style.updateApp, onClick: showNewVersionDesc, style: containerStyle },
        React.createElement("div", { className: style.updateAppIcon }),
        React.createElement("div", { className: style.updateAppText }, getIn18Text('BANBENSHENGJI'))));
};
export default UpdateApp;
